import { GrapevineGroupApi } from '@DigitaleDoerfer/digitale-doerfer-api';
import { useMemo } from 'react';

import { useApiConfiguration } from '@/features/api/hooks/useApiConfiguration';

export const useGrapevineGroupApi = () => {
  const configuration = useApiConfiguration();
  return useMemo(() => new GrapevineGroupApi(configuration), [configuration]);
};
